import { render, staticRenderFns } from "./SylvanaFirstOpen.vue?vue&type=template&id=38782147&"
import script from "./SylvanaFirstOpen.vue?vue&type=script&lang=ts&"
export * from "./SylvanaFirstOpen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports